<template>
  <div class="sf-category-menu-card" data-testid="product-card">
    <div class="sf-category-menu-card__image-wrapper">
      <slot
        name="image"
        v-bind="{
          image,
          title,
          link,
          imageHeight,
          imageWidth,
          categoryUrlPath,
          name,
        }"
      >
        <slot name="title" v-bind="{ name, categoryUrlPath }">
          <SfButton
            @click="goToDetail(categoryUrlPath)"
            class="sf-button--pure sf-category-menu-card__link"
            data-testid="product-link"
            v-on="$listeners"
          >
            <span class="sf-category-menu-card__title">
              {{ name }}
            </span>
          </SfButton>
        </slot>
        <SfButton
          @click="goToDetail(categoryUrlPath)"
          class="sf-button--pure sf-category-menu-card__link"
          data-testid="product-link"
          aria-label="Go To Product"
          v-on="$listeners"
        >
          <template v-if="Array.isArray(image)">
            <SfImage
              v-for="(picture, key) in image.slice(0, 2)"
              :key="key"
              class="sf-category-menu-card__picture"
              :src="picture"
              :alt="title"
              :width="imageWidth"
              :height="imageHeight"
            />
          </template>

          <SfImage
            v-else
            class="sf-category-menu-card__image"
            :src="image"
            :alt="title"
            :width="imageWidth"
            :height="imageHeight"
          />
        </SfButton>

        <SfButton
          @click="goToDetail(categoryUrlPath)"
          class="sf-category-menu-card__sf-button"
          :aria-disabled="false"
        >
          {{ $t("Shop Now") }}
        </SfButton>
      </slot>
    </div>
  </div>
</template>
<script>
import { colorsValues as SF_COLORS } from "@storefront-ui/shared/variables/colors";
import { SfIcon, SfImage, SfButton } from "@storefront-ui/vue";

export default {
  name: "SfCategoryMenuCard",
  components: {
    SfIcon,
    SfImage,
    SfButton,
  },
  props: {
    image: {
      type: [Array, Object, String],
      default: "",
    },
    imageWidth: {
      type: [Number, String],
      default: null,
    },
    imageHeight: {
      type: [Number, String],
      default: null,
    },

    title: {
      type: String,
      default: "",
    },
    link: {
      type: [String, Object],
      default: null,
    },
    /**
     * Link element tag
     * @deprecated will be removed in 1.0.0 use slot to replace content
     */
    categoryUrlPath: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isAddingToCart: false,
      openColorPicker: false,
    };
  },
  methods: {
    goToDetail(categoryUrlPath) {
      this.$router.push(categoryUrlPath);
    },
  },
};
</script>
<style lang="scss">
@import "../styles/SfCategoryMenuCard.scss";
</style>
